<div class="a-dynamic-dialog-title p-dialog-titlebar p-widget-header p-helper-clearfix p-corner-top"
  [ngClass]="titleClass" *ngIf="showHeader">
  <span class="p-dialog-title">
    <ng-container *ngTemplateOutlet="headerTemplate||defaultHeader;context:headerTemplateContext"></ng-container>
  </span>
  <div class="p-dialog-titlebar-icons">
    <a [ngClass]="'p-dialog-titlebar-icon p-dialog-titlebar-close p-corner-all'" tabindex="0" role="button"
      (click)="close()" (keydown.enter)="close()" *ngIf="closable !== false">
      <span class="pi pi-times"></span>
    </a>
  </div>
</div>
<div class="a-message" [ngStyle]="messageStyle" [ngClass]="messageStyleClass">
  <div class="a-message-body">
    <ng-container #insertPoint>
    </ng-container>
  </div>
  <div class="a-message-footer">
    <ng-container *ngTemplateOutlet="footerTemplate||defaultFooter;context:footerTemplateContext"></ng-container>
  </div>
</div>
<ng-template #defaultBody>
  <div class="a-message-l1text" *ngIf="l1text&&l1text.length">{{l1text}}</div>
  <div class="a-message-l2text" *ngFor="let item of l2text">{{item}}</div>
  <!-- <div class="a-message-l2text" *ngIf="l2text&&l2text.length">{{l2text}}</div> -->
</ng-template>
<ng-template #defaultFooter>
  <div class="a-message-footer-container">
    <div class="button-panel">
      <button class="secondary-button a-btn-secondary" type="button" pButton label="{{secondaryButtonText}}"
        (click)="onSecondaryButtonClick()" *ngIf="!isSecondaryButtonHidden"></button>
      <button class="main-button a-btn-primary" type="button" pButton label="{{mainButtonText}}"
        [disabled]="isMainButtonDisable" (click)="onMainButtonClick()"></button>
    </div>
    <p-checkbox *ngIf="isShowMessageAgainVisible" [(ngModel)]="doNotShowAgain" binary="true"
      label="{{doNotShowAgainMsg||'Do not show this message again'}}"></p-checkbox>
  </div>
</ng-template>
<ng-template #innerHtmlBody>
  <div [innerHTML]="innerHTML"></div>
</ng-template>

<ng-template #defaultHeader>
  {{header}}
</ng-template>